var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewPaymentplan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#0061FF",
    d: "M15 18.75L11.25 18.75 11.25 22.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0061FF",
    d: "M22.667 19.483c-.817 2.387-3.135 3.927-5.651 3.755-2.517-.172-4.604-2.013-5.089-4.488M19.5 15.75L23.25 15.75 23.25 12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0061FF",
    d: "M11.833 15.017c.817-2.387 3.135-3.927 5.651-3.755 2.517.172 4.604 2.013 5.089 4.488"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M3.75 6.75L14.25 6.75M3.75 11.25L9.75 11.25M3.75 15.75L7.5 15.75M7.5 20.25H2.25c-.828 0-1.5-.672-1.5-1.5V2.25c0-.828.672-1.5 1.5-1.5h10.629c.398 0 .779.158 1.06.439l2.872 2.872c.281.281.439.662.439 1.06V7.5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPaymentplan);
export default __webpack_public_path__ + "static/media/view-paymentplan.fac1877701b2420c941e94664b08f951.svg";
export { ForwardRef as ReactComponent };